import z from 'zod'
import { states } from './generic'
import { OrgSettingsSchema } from './org'

// Derive from OrgSettingsSchema to stay aligned with org settings.
// - Omit `address` (not collected at signup) and `email` (renamed to `orgEmail`)
// - Override `licenseeName` and `licenceExpiry` as optional for signup
// - Add `orgName`, `state`, and `orgEmail`
const orgSettingsForSignup = OrgSettingsSchema.omit({ address: true, email: true }).extend({
    licenseeName: z.string().optional(),
    licenceExpiry: z.string().optional(),
})

export const CreateOrgInputSchema = orgSettingsForSignup.extend({
    orgName: z.string().min(1, 'Organisation name is required'),
    state: z.enum(states, { required_error: 'State is required' }),
    orgEmail: z.string().email('Please enter a valid email'),
    // Optional affiliate referral code captured from the `?ref=` link at signup.
    // Length-capped as a defensive guard; a malformed code is resolved-or-ignored server-side
    // (best-effort attribution), so we don't hard-reject and block signup on it.
    ref: z.string().max(64).optional(),
})

export type CreateOrgInput = z.infer<typeof CreateOrgInputSchema>
